import * as React from "react";
import {
  Switch,
  Route,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";
import TabRoutePage from "./tabRoutePage";
import { URLDefinition } from "@vingle/wtf-sdk/url/definition";
import { VingleRedirect } from "@vingle/wtf-sdk/components/vingleRedirect";

export interface IRoutedTab extends Vingle.ITab {
  url: URLDefinition | URLDefinition[];
  qs?: { [key: string]: string };
  exact?: boolean;
}

interface IProps extends RouteComponentProps<Vingle.IMatchParams> {
  tabs: IRoutedTab[];
  vingleTabType: Vingle.VingleTabType;
  onTabChange?: (selectedTab: IRoutedTab) => void;
  wrapperClassName?: string;
  tabBarClassName?: string;
  accessibilityLevel?: number;

  enableStickyNavBar?: boolean;
  stickyThreshold?: number;
  stickedTopOffset?: number | string;
  stickyChildrenWrapperClassName?: string;
}

const getDefaultTab = (tabs: IRoutedTab[]): IRoutedTab => {
  return tabs.find(tab => Boolean(tab.default)) || tabs[0];
};

class RoutedVingleTab extends React.Component<IProps> {
  public render() {
    const {
      tabs,
      vingleTabType,
      accessibilityLevel,
      wrapperClassName,
      tabBarClassName,
      enableStickyNavBar,
      stickyThreshold,
      stickedTopOffset,
      stickyChildrenWrapperClassName,
    } = this.props;
    const defaultTab = this.getDefaultTab();
    return (
      <Switch>
        {tabs.map(tab => {
          return (
            <Route
              key={tab.key}
              exact={tab.exact !== false}
              path={(Array.isArray(tab.url) ? tab.url : [tab.url]).map(url =>
                url.constructor.toString(),
              )}
              // tslint:disable-next-line:jsx-no-lambda
              render={props => {
                return (
                  <TabRoutePage
                    tabs={tabs}
                    selectedTab={tab}
                    accessibilityLevel={accessibilityLevel}
                    wrapperClassName={wrapperClassName}
                    tabBarClassName={tabBarClassName}
                    onTabClick={this.handleClick}
                    vingleTabType={vingleTabType}
                    enableStickyNavBar={enableStickyNavBar}
                    stickyThreshold={stickyThreshold}
                    stickedTopOffset={stickedTopOffset}
                    stickyChildrenWrapperClassName={
                      stickyChildrenWrapperClassName
                    }
                    {...props}
                  />
                );
              }}
            />
          );
        })}
        <VingleRedirect
          to={
            Array.isArray(defaultTab.url) ? defaultTab.url[0] : defaultTab.url
          }
          qs={defaultTab.qs}
        />
      </Switch>
    );
  }

  private readonly handleClick = (selectedTab: IRoutedTab) => {
    if (this.props.onTabChange) this.props.onTabChange(selectedTab);
  };

  private readonly getDefaultTab = (): IRoutedTab => {
    return getDefaultTab(this.props.tabs);
  };
}

export default withRouter(RoutedVingleTab);
